"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateInput = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _Input = require("../../../../elements/input/Input");
var _react = _interopRequireWildcard(require("react"));
var _calendar = require("../../../../assets/icons/calendar.svg");
var _caretDown = require("../../../../assets/icons/caret-down.svg");
var _close = require("../../../../assets/icons/close.svg");
var _dateInputModule = _interopRequireDefault(require("./date-input.module.scss"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _dateFns = require("date-fns");
var _format = require("../../../../utils/dates/format");
var _useDateValidation = require("../../hooks/useDateValidation");
var _excluded = ["id", "className", "onChange", "onClick", "onIconClick", "onClearClick", "disabled", "error", "value"];
var DateInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    className = _ref.className,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    onIconClick = _ref.onIconClick,
    onClearClick = _ref.onClearClick,
    disabled = _ref.disabled,
    error = _ref.error,
    value = _ref.value,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  (0, _useDateValidation.useDateValidation)(id);
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  (0, _react.useEffect)(function () {
    setInputValue(value);
  }, [value]);
  var handleClearClick = function handleClearClick(e) {
    onChange({
      currentTarget: {
        value: ''
      },
      target: {
        value: ''
      }
    });
    onClearClick(e);
  };
  var handleOnChange = function handleOnChange(e) {
    var newValue = e.currentTarget.value;
    setInputValue(newValue);
    if (newValue === '' || newValue.length === _format.shortDateFormat.length && (0, _dateFns.isValid)((0, _dateFns.parse)(newValue, _format.shortDateFormat, new Date()))) {
      onChange({
        currentTarget: {
          value: e.currentTarget.value
        },
        target: {
          value: e.target.value
        }
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: disabled ? undefined : onClick,
    className: _dateInputModule.default['date-input']
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: disabled ? undefined : function (e) {
      e.stopPropagation();
      onIconClick(e);
    },
    className: (0, _classnames3.default)(_dateInputModule.default['date-input__icon'], 'react-datepicker-ignore-onclickoutside', (0, _defineProperty2.default)({}, _dateInputModule.default['date-input__icon--clickable'], !disabled))
  }, /*#__PURE__*/_react.default.createElement(_calendar.ReactComponent, {
    "data-testid": "calendar-icon"
  })), /*#__PURE__*/_react.default.createElement(_Input.Input, Object.assign({}, rest, {
    id: id,
    autoComplete: 'off',
    value: inputValue,
    disabled: disabled,
    error: error,
    className: (0, _classnames3.default)(_dateInputModule.default['date-input__input'], 'react-datepicker-ignore-onclickoutside'),
    onChange: handleOnChange,
    ref: ref
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_dateInputModule.default['date-input__suffix-icon'], 'react-datepicker-ignore-onclickoutside', (0, _defineProperty2.default)({}, _dateInputModule.default['date-input__suffix-icon--clickable'], !disabled)),
    onClick: disabled ? undefined : function (e) {
      e.stopPropagation();
      value ? handleClearClick(e) : onIconClick(e);
    }
  }, value ? /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
    "data-testid": "clear-icon"
  }) : /*#__PURE__*/_react.default.createElement(_caretDown.ReactComponent, {
    "data-testid": "caret-down-icon"
  })));
});
exports.DateInput = DateInput;
DateInput.displayName = 'DateInput';